// extracted by mini-css-extract-plugin
export default {"notification":"notification_notification__VDbg4","success":"notification_success__fLnT3","error":"notification_error__oFG2K"};